import type { CanActivateChildFn, Route } from '@angular/router';
import { autoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';
import { environment } from '../environments/environment';

const sessionGuards: CanActivateChildFn[] = environment.useMocks ? [] : [autoLoginPartialRoutesGuard];

export const appRoutes: Route[] = [
  {
    path: '',
    canActivateChild: sessionGuards,
    children: [
      {
        path: '',
        loadChildren: (): Promise<Route[]> =>
          import('@partou/my-group/feature').then((module): Route[] => module.MyGroupRoutes),
      },
      {
        path: 'forbidden',
        loadChildren: (): Promise<Route[]> =>
          import('@partou/authentication').then((module): Route[] => module.AuthenticationRoutes),
      },
    ],
  },
  // OIDC redirect-callback landing for environments whose registered HelloID redirect URI carries a
  // /authorize suffix (test). checkAuth runs in an app initializer before routing, so this route just
  // bounces into the app once the callback has been processed.
  { path: 'authorize', redirectTo: '', pathMatch: 'full' },
  {
    path: 'unauthorized',
    loadChildren: (): Promise<Route[]> =>
      import('@partou/authentication').then((module): Route[] => module.AuthenticationRoutes),
  },
];
